<template>
  <div >
    <ul class="sidebar-nav lms-nav">
          <li class="nav-item">
            <a class="nav-link nav-descr text-uppercase d-flex align-items-center">
              <span class="pt-1">Шинэ ажилтан</span> <feather type="star" class="text-orange-600 ml-2 -mt-2"></feather>
            </a>
          </li>
          <li class="nav-item" >
            <router-link :to="{ name: 'buddyParticipant' }"
              class="nav-link openbook" :class="{ active: $route.name == 'buddyParticipant' }" >
              Тавтай морил
            </router-link>
          </li>
          <li class="nav-item" >
            <router-link :to="{ name: 'lmsProfile', params: { id: 0 } }"
              class="nav-link tickdouble" :class="{ active: $route.name == 'lmsProfile1' }" >
              Checklist
            </router-link>
          </li>
          <li class="nav-item" >
            <router-link :to="{ name: 'buddyExam', params: { id: 0 } }"
              class="nav-link star" :class="{ active: $route.name == 'buddyExam' }" >
              Шинэ ажилтаны шалгалт
            </router-link>
          </li>
          <li class="nav-item" >
            <router-link :to="{ name: 'buddyFaq', params: { id: 0 } }"
              class="nav-link collection" :class="{ active: $route.name == 'buddyFaq' }" >
              FAQ
            </router-link>
          </li>
        </ul>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import svgIcon from "@/assets/svg/all.vue";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    svgIcon,
    vueCustomScrollbar,
  },
  props: {
    
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    this.fetchResBase();
  },
  mounted() {
  },
  methods: {
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
  },
};
</script>

<style></style>
